import { render, staticRenderFns } from "./PayMethodItem.vue?vue&type=template&id=f0c42f58"
import script from "./PayMethodItem.vue?vue&type=script&lang=js"
export * from "./PayMethodItem.vue?vue&type=script&lang=js"
import style0 from "./PayMethodItem.vue?vue&type=style&index=0&id=f0c42f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports